import "./App.css";
import TMGClaimSystem from "./TMGClaimSystem";

const MAINTENANCE_BYPASS_STORAGE_KEY = "tmgMaintenanceBypass";

function isMaintenanceBypassed() {
  const params = new URLSearchParams(window.location.search);
  const bypassParam = params.get("maintenance_bypass");
  const bypassKey = process.env.REACT_APP_MAINTENANCE_BYPASS_KEY;

  if (bypassKey && bypassParam === bypassKey) {
    sessionStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, "true");
    return true;
  }

  return sessionStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY) === "true";
}

function MaintenancePage() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FFD200",
        color: "#111827",
        textAlign: "center",
        padding: "24px",
      }}
    >
      <h1
        style={{
          margin: 0,
          fontSize: "clamp(28px, 5vw, 48px)",
          fontWeight: 700,
          lineHeight: 1.2,
        }}
      >
        Website is under maintanance
      </h1>
    </main>
  );
}

function App() {
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  if (maintenanceMode && !isMaintenanceBypassed()) {
    return <MaintenancePage />;
  }

  return <TMGClaimSystem />;
}

export default App;
